/* artvision® · Galerie · „Weitere Werke entdecken“ (GAL-01)
   1. Der Link bekommt beim Klick eine zufällige Sortierung, damit die
      Galerie jedes Mal anders beginnt.
   2. Steht ?pv_mix=1 in der Adresse, werden die Werke der ersten Seite
      zusätzlich gemischt (Beratungszeilen bleiben an ihrem Platz). */
(function () {
  var SORTS = ['created-descending', 'best-selling', 'price-ascending', 'price-descending', 'title-ascending'];

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-pv-mix-link]');
    if (!a) return;
    try {
      var u = new URL(a.getAttribute('href'), window.location.href);
      u.searchParams.set('sort_by', SORTS[Math.floor(Math.random() * SORTS.length)]);
      u.searchParams.set('pv_mix', '1');
      a.setAttribute('href', u.pathname + u.search);
    } catch (err) { /* Link bleibt wie er ist */ }
  }, true);

  function shuffle() {
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
    if (params.get('pv_mix') !== '1') return;
    var list = document.querySelector('#product-grid ul');
    if (!list) return;
    var items = Array.prototype.filter.call(list.children, function (li) {
      return li.classList.contains('grid__item') && !li.classList.contains('pv-journey-slot');
    });
    if (items.length < 2) return;
    var slots = items.map(function (li) { var mark = document.createComment('pv'); list.insertBefore(mark, li); return mark; });
    for (var i = items.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = items[i]; items[i] = items[j]; items[j] = t;
    }
    slots.forEach(function (mark, n) { list.insertBefore(items[n], mark); mark.remove(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', shuffle); else shuffle();
})();
